export class NICEPOC {
    ContactAddress: string;
    ContactCode: string;
    ContactDescription: string;
    DefaultSkillId: number;
    IsActive: boolean;
    MediaTypeName: string;
    MediaTypeId: number;
    Notes: string;
    OutBoundSkill: boolean;
    ScriptName: string;
    SkillName: string;
    mediaTypeIcon: string;

    constructor(nicepoc?) {
        if (nicepoc) {
            this.ContactAddress = nicepoc.contactAddress || '';
            this.ContactCode = nicepoc.contactCode || '';
            this.ContactDescription = nicepoc.contactDescription || '';
            this.MediaTypeName = nicepoc.mediaTypeName || '';
            this.MediaTypeId = nicepoc.mediaTypeId || '';
            this.Notes = nicepoc.notes || '';
            this.IsActive = nicepoc.isActive;
            this.OutBoundSkill = nicepoc.outBoundSkill || false;
            this.DefaultSkillId = nicepoc.defaultSkillId || null;
            this.ScriptName = nicepoc.scriptName || '';
            this.SkillName = '';
        } else {
            this.ContactAddress = '';
            this.ContactCode = '';
            this.ContactDescription = '';
            this.MediaTypeName = '';
            this.Notes = '';
            this.IsActive = true;
            this.OutBoundSkill = false;
            this.DefaultSkillId = null;
            this.ScriptName = '';
            this.MediaTypeId = 0;
            this.SkillName = '';
        }
        this.mediaTypeIcon = this.getIcon();
    }
    getupdatePOC(): any {

        return {
            pointOfContactName: this.ContactDescription,
            skillId: this.DefaultSkillId,
            isActive: this.IsActive,
            scriptName: this.ScriptName,
            ivrReportingEnabled: true,
            chatProfileId: null
        };
    }

    private getIcon(): string {
        switch (this.MediaTypeName) {
            // Email
            case 'E-Mail':
                return 'email';
            // FAX
            case 'Fax':
                return 'fax';
            // Chat
            case 'Chat':
                return 'chat';
            // Phone
            case 'Phone Call':
                return 'phone';
            // Voicemail
            case 'Voice Mail':
                return 'voicemail';
            // Work Item
            case 'Work Item':
                return 'confirmation_number';
            // SMS
            case 'SMS':
                return 'chat';
            // Social
            case 'Social':
                return 'social';
            // Digital
            case 'Digital':
                return 'forum';
        }
    }
}
